import React, { ReactNode } from "react";
import { Box, BoxProps, Tooltip } from "@chakra-ui/react";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import { BASKET_BULK_ORDER_LIMIT } from "@/features/pathpick/features/basket/constants";

interface Props {
  // 선택이 일괄 주문 한도를 넘어 주문이 막힌 동안만 안내를 띄운다.
  isActive: boolean;
  // 버튼 대신 감싸는 요소가 레이아웃을 맡아야 할 때(반응형 폭 등) 넘긴다.
  wrapperProps?: BoxProps;
  children: ReactNode;
}

// 주문 버튼 안내 툴팁 — 비활성 버튼은 마우스 이벤트를 받지 않아 버튼을 감싼 요소에 툴팁을 건다.
function PathPickBasketOrderLimitTooltip({
  isActive,
  wrapperProps,
  children,
}: Props) {
  const { t } = useI18nHelper();

  return (
    <Tooltip
      label={t("path_pick:basket.order.limit_tooltip", {
        count: BASKET_BULK_ORDER_LIMIT,
      })}
      isDisabled={!isActive}
      hasArrow
      placement={"top"}
    >
      <Box display={"inline-flex"} {...wrapperProps}>
        {children}
      </Box>
    </Tooltip>
  );
}

export default PathPickBasketOrderLimitTooltip;
